import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { userContext } from "../../App";
import {
  Col,
  Card,
  Row,
  Button,
  Nav,
  InputGroup,
  FormControl,
} from "react-bootstrap";
export const FavBage = () => {
  const [book, setBook] = useState();
  const [status, setStatus] = useState();

  const state = useContext(userContext);
  const token = state.token;

  const getAllFavo = () => {
    axios
      .get("https://c3-bookshop.herokuapp.com/favorite/getAllFav/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setBook(res.data.message);
      })
      .catch((err) => {
        setBook([]);
      });
  };

  useEffect(() => {
    getAllFavo();
  }, []);

  const deleteBook = (id) => {
    axios
      .delete(`https://c3-bookshop.herokuapp.com/favorite/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        getAllFavo();
        setStatus(<div>{`Success deleted the book with id=>${id}`}</div>);
      })
      .catch((err) => {
        setStatus(<div>Some thing wrong</div>);
      });
  };

  return (
    <>
    <div className="container">
      <h1>Your Favourite Books</h1>
      <Row xs={1} md={4} className="g-4">
        
        {book && book.map((element, i) => {
          return (
            <div className="container">
              <Col key={element.bookId.id}>
                <Card
                  style={{
                    textAlign: "left",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <Card.Img
                    variant="top"
                    src={element.bookId.image}
                    height="200px"
                    width="200px"
                  />
                  <Card.Body style={{ height: "200px" }}>
                    <Card.Title
                      style={{ fontSize: "18px", display: "flex" }}
                    >
                      {element.bookId.name}{" "}
                    </Card.Title>

                    <Card.Text style={{ fontSize: "16px" }}>
                      Price: {element.bookId.price} $
                    </Card.Text>
                    <Card.Text
                      style={{ fontSize: "16px", textAlign: "center" }}
                    >
                      <h1
                        onClick={() => {
                          deleteBook(element._id, element.bookId._id);
                        }}
                        className="trash"
                      >
                        🗑️
                      </h1>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </div>
          );
        })}
      </Row>
    </div>
  </>
    // <>
    //   <div className="contaner">
    //     {!book ? (
    //       <div>Shopping cart is Empty</div>
    //     ) : (
    //       <>
    //         {book.map((element, i) => {
    //           return (
    //             <div className="card">
    //               <img src={element.bookId.image} className="img9" />
    //               <h3>{element.bookId.name}</h3>
    //               <p class="price231">Price: {element.bookId.price}JD</p>
    //               <p>
    //                 <button
    //                   onClick={() => {
    //                     deleteBook(element._id, element.bookId._id);
    //                   }}
    //                 >
    //                   Remove Item
    //                 </button>
    //               </p>
    //             </div>
    //           );
    //         })}
    //       </>
    //     )}
    //   </div>
    // </>
  );
};
